import {http} from './config/config-ficha'
export default{
    listar:()=>{
        return http.get('emergencys',{
            headers:{
                'Authorization':'10635a31-c346-4077-94de-feca871f83c8'
            }
        })
    },
    listarByMap:(map)=>{
        return http.get(`emergencys/${map}`,{
            headers:{
                'Authorization':'10635a31-c346-4077-94de-feca871f83c8'
            }
        })
    },
    salvar:(ficha)=>{
        return http.post('emergencys', ficha,{
            headers:{
                'Authorization':'10635a31-c346-4077-94de-feca871f83c8'
            }
        })
    },
    atualizar:(ficha)=>{
        return http.put('emergencys', ficha,{
            headers:{
                'Authorization':'10635a31-c346-4077-94de-feca871f83c8'
            }
        })
    }
}